<template>
  <v-container fluid class="pa-0">
    <template v-if="noDocument">
      <navigation :color="color" :flat="flat" />
      <v-main class="pt-0">
        <home />
        <about />
        <!-- <download /> -->
        <pricing />
        <contact />
      </v-main>
      <v-scale-transition>
        <v-btn
          fab
          v-show="fab"
          v-scroll="onScroll"
          dark
          fixed
          bottom
          right
          color="secondary"
          @click="toTop"
        >
          <v-icon>mdi-arrow-up</v-icon>
        </v-btn>
      </v-scale-transition>
      <foote />
    </template>
    <terms-and-conditions v-if="showTerms" />
    <privacy-policy v-else-if="showPrivacy" />
  </v-container>
</template>

<style scoped>
.v-main {
  background-image: url("~@/assets/img/bgMain.png");
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
}
</style>

<script>
import navigation from "@/components/Navigation";
import foote from "@/components/Footer";
import home from "@/components/HomeSection";
import about from "@/components/AboutSection";
// import download from "./components/DownloadSection";
import pricing from "@/components/PricingSection";
import contact from "@/components/ContactSection";
import TermsAndConditions from "@/components/TermsAndConditions.vue";
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";

export default {
  name: "App",

  components: {
    navigation,
    foote,
    home,
    about,
    // download,
    pricing,
    contact,
    TermsAndConditions,
    PrivacyPolicy,
  },

  data: () => ({
    fab: null,
    color: "",
    flat: null,
  }),

  computed: {
    noDocument() {
      return (
        this.$route.query.document === "" || this.$route.query.document == null
      );
    },
    showPrivacy() {
      return this.$route.query.document === "privacy-policy";
    },
    showTerms() {
      return this.$route.query.document === "terms-and-conditions";
    },
  },

  created() {
    const top = window.pageYOffset || 0;
    if (top <= 60) {
      this.color = "transparent";
      this.flat = true;
    }
  },

  watch: {
    fab(value) {
      if (value) {
        this.color = "secondary";
        this.flat = false;
      } else {
        this.color = "transparent";
        this.flat = true;
      }
    },
  },

  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
